export const STRIPE_ZERO_DECIMAL_CURRENCIES = new Set([
  'bif',
  'clp',
  'djf',
  'gnf',
  'huf',
  'jpy',
  'kmf',
  'krw',
  'mga',
  'pyg',
  'rwf',
  'vnd',
  'vuv',
  'xaf',
  'xof',
  'xpf',
]);

export const stripeMinorUnitsFromMajorAmount = (
  majorAmount: number,
  currencyCode: string | undefined,
): number => {
  const c = (currencyCode || 'USD').toLowerCase();
  const m = Number(majorAmount);
  if (Number.isNaN(m)) return 0;
  if (STRIPE_ZERO_DECIMAL_CURRENCIES.has(c)) {
    return Math.max(0, Math.round(m));
  }
  return Math.max(0, Math.round(m * 100));
};

export const walletAmountStringFromMajor = (
  majorAmount: number,
  currencyCode: string | undefined,
): string => {
  const c = (currencyCode || 'USD').toLowerCase();
  const m = Number(majorAmount);
  if (Number.isNaN(m)) return '0';
  if (STRIPE_ZERO_DECIMAL_CURRENCIES.has(c)) {
    return String(Math.max(0, Math.round(m)));
  }
  return Math.max(0, m).toFixed(2);
};

export const analyticsMinorUnitsFromPrice = (
  priceMajor: number,
  currencyCode: string | undefined,
): number => stripeMinorUnitsFromMajorAmount(priceMajor, currencyCode);
